export default "__VITE_ASSET__DqLuIhrp__"